import { css } from 'aphrodite';
import * as React from 'react';
import { inboxStyles as s } from './styles/inboxStyles';

/** Label-left / value-right metadata row, shared by every block in the ticket details drawer. */
export const DetailRow: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
	<div className={css(s.detailRow)}>
		<span className={css(s.detailKey)}>{label}</span>
		<span className={css(s.detailValue)}>{children}</span>
	</div>
);
